import EntityManager from '@/pages/admin/components/EntityManager';
import { testimonialFields, testimonialColumns } from '@/pages/admin/entityConfigs';

export default function TestimonialsPage() {
  return (
    <EntityManager
      table="testimonials"
      fields={testimonialFields}
      columns={testimonialColumns}
      orderBy="created_at"
      searchKeys={['name', 'role']}
      addLabel="Add Testimonial"
    />
  );
}